/**
 * The payment fields drawn in the brand (rc2, B-3): what `Design\Brand::client()` hands a page through its configuration block
 * (`window.AnudanEngine.config.brand`). Stripe's card fields take `appearance` and `fonts` when its Elements are made; PayPal's
 * button takes `style`. A page without the block gets each provider's own look, as before.
 */

/**
 * The brand's part of the page's configuration.
 *
 * @return {Object}
 */
function brand() {
	const config = ( window.AnudanEngine && window.AnudanEngine.config ) || {};

	return config.brand || {};
}

/**
 * The options for `stripe.elements()`, merged with the caller's own (`clientSecret`).
 *
 * @param {Object} [options] The caller's options.
 * @return {Object}
 */
export function stripeElementsOptions( options = {} ) {
	const { stripe, stripeFonts } = brand();
	const out = { ...options };

	if ( stripe ) {
		out.appearance = stripe;
	}

	if ( Array.isArray( stripeFonts ) && stripeFonts.length > 0 ) {
		out.fonts = stripeFonts;
	}

	return out;
}

/**
 * The Payment Element's own options (R2-03, rc2): a card, with Apple Pay and Google Pay inside it where the device has them, and
 * never Link. Apple Pay and Google Pay show "when the Payment Intent has the `card` payment method and the customer is using a
 * supported platform", and a wallet set to `never` is not offered
 * (https://docs.stripe.com/js/elements_object/create_payment_element, `wallets`). The server asks for a card only.
 *
 * @return {Object}
 */
export function paymentElementOptions() {
	return { wallets: { applePay: 'auto', googlePay: 'auto', link: 'never' } };
}

/**
 * PayPal's button style: one white PayPal button (B2, decided 2026-10-26).
 *
 * @return {Object|undefined}
 */
export function paypalButtonStyle() {
	return brand().paypal || undefined;
}
